module.exports = __webpack_public_path__ + "static/c8-c0038117883a12dd362148ecbc3aec00.png";